module.exports = __webpack_public_path__ + "static/media/magazine.d33e8e9e.png";